import { connect } from 'react-redux';

import { hideModal } from 'actions/ModalActions';
import { ModalActionTypes } from 'actions/types/ModalActionTypes';

import ConfigureAddressCollectionWelcomeModal from './ConfigureAddressCollectionWelcomeModal';
import type { AppDispatch } from '../../../../../reducers';

export type ConfigureAddressCollectionWelcomeModalDispatchProps = {
  onCloseModal: () => void;
};

const mapDispatchToProps = (
  dispatch: AppDispatch
): ConfigureAddressCollectionWelcomeModalDispatchProps => ({
  onCloseModal: (): ModalActionTypes => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(ConfigureAddressCollectionWelcomeModal);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionWelcomeModal/index.ts